import React, { useState, useEffect } from "react";
import Cookies from "js-cookie";
import { styled } from "@mui/material/styles";
import Button from "@mui/material/Button";
import CloseIcon from "@mui/icons-material/Close";
import TextField from "@mui/material/TextField";
import { Slide, toast } from "react-toastify";
import { Tooltip, IconButton, Modal, Box, Autocomplete } from "@mui/material";
import "../../../../style/setup.css";

const BootstrapButton = styled(Button)({
  boxShadow: "none",
  textTransform: "none",
  fontSize: 14,
  padding: "5px 10px",
  border: "1px solid",
  width: "fit-content",
  height: "100%",
  lineHeight: 1.5,
  backgroundColor: "#069DAE",
  fontFamily: ["Roboto"].join(","),
  "&:hover": {
    backgroundColor: "#0696A6",
    boxShadow: "none",
  },
  "&:active": {
    boxShadow: "none",
    backgroundColor: "#0062cc",
    borderColor: "#005cbf",
  },
  "&:focus": {
    boxShadow: "0 0 0 0.2rem rgba(0,123,255,.5)",
  },
});

function ModalCreateRegency({
  refreshData,
  modalCreateRegency,
  setModalCreateRegency,
  provinceSelectedId,
  provinceName,
  setProvinceName,
}) {
  const accessToken = Cookies.get("access_token") || "";

  const [dataAreas, setDataAreas] = useState([]);

  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    const handler = setTimeout(() => {
      if (modalCreateRegency) {
        fetchArea();
        if (provinceSelectedId) {
          setNewData((prevData) => ({
            ...prevData,
            province_id: provinceSelectedId,
          }));
        }
      }
    }, 200);
    return () => {
      clearTimeout(handler);
    };
  }, [accessToken, modalCreateRegency]);

  async function fetchArea() {
    const token = Cookies.get("access_token");

    setDataAreas([]);
    setIsLoading(true);

    const queryParams = new URLSearchParams();

    const queryString = queryParams.toString();
    const apiUrl =
      `${process.env.REACT_APP_API_URL}/api/v1/area-breakdown` +
      (queryString ? `?${queryString}` : "");

    try {
      const response = await fetch(apiUrl, {
        method: "GET",
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });

      if (response.ok) {
        const { data } = await response.json();
        const newArray = data.map((item) => ({
          label: item.area,
          value: item.area,
        }));
        setDataAreas(newArray);
      } else {
        setDataAreas([]);
      }
    } catch (error) {
      setDataAreas([]);
    }
    setIsLoading(false);
  }

  const [newData, setNewData] = useState({
    province_id: provinceSelectedId || "",
    code: "",
    name: "",
    area: "unspecify",
  });

  const handleSetupInputChange = (event) => {
    const { name, value } = event.target;
    setNewData({
      ...newData,
      [name]: value,
    });
  };

  const handleCreateData = async () => {
    const token = Cookies.get("access_token");
    try {
      const response = await fetch(
        `${process.env.REACT_APP_API_URL}/api/v1/regency`,
        {
          method: "POST",
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
          },
          body: JSON.stringify(newData),
        }
      );

      if (response.status === 201) {
        toast.success("Data berhasil dibuat!", {
          position: "top-right",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "light",
          transition: Slide,
        });
        refreshData();
        setModalCreateRegency(false);
        setNewData({
          province_id: "",
          code: "",
          name: "",
          area: "unspecify",
        });
      } else if (response.status == 422) {
        toast.error("Data gagal diproses!", {
          position: "top-right",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "light",
          transition: Slide,
        });
      } else {
        const data = await response.json();
        toast.error(data.detail || "Data gagal dibuat!", {
          position: "top-right",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "light",
          transition: Slide,
        });
      }
    } catch (error) {
      console.error("Error creating Data:", error);
    }
  };

  return (
    <Modal
      open={modalCreateRegency}
      onClose={() => {
        setModalCreateRegency(false);
        setProvinceName("");
      }}
      aria-labelledby="modal-modal-title"
      aria-describedby="modal-modal-description"
      sx={{ border: 0 }}
    >
      <Box
        sx={{
          position: "absolute",
          top: "50%",
          left: "50%",
          transform: "translate(-50%, -50%)",
          width: {
            xs: "90vw",
            sm: 400,
          },
          maxHeight: "90vh",
          bgcolor: "background.paper",
          border: "0px solid #000",
          boxShadow: 24,
          p: {
            xs: 2,
            sm: 4,
          },
          overflowY: "auto",
          borderRadius: 2,
        }}
      >
        <Tooltip title="Close Modal">
          <IconButton
            edge="end"
            color="inherit"
            onClick={() => setModalCreateRegency(false)}
            sx={{ position: "absolute", top: 20, right: 30 }}
          >
            <CloseIcon />
          </IconButton>
        </Tooltip>
        <div className="create-data">
          <h2 style={{ marginBottom: "15px" }}>Create Kab/Kota</h2>
          <div>
            <p>
              Provinsi : <span style={{ fontWeight: 700 }}>{provinceName}</span>
            </p>
          </div>
          <div>
            <TextField
              label="KODE"
              name="code"
              value={newData.code}
              onChange={handleSetupInputChange}
              sx={{ width: "100%", mb: 2 }}
            />
          </div>
          <div>
            <TextField
              label="NAME"
              name="name"
              value={newData.name}
              onChange={handleSetupInputChange}
              sx={{ width: "100%", mb: 2 }}
            />
          </div>
          <div>
            <Autocomplete
              options={dataAreas}
              getOptionLabel={(option) => option.label}
              value={
                dataAreas.find((option) => option.value === newData.area) ||
                null
              }
              onChange={(event, newValue) => {
                handleSetupInputChange({
                  target: {
                    name: "area",
                    value: newValue ? newValue.value : "",
                  },
                });
              }}
              sx={{ mb: 2 }}
              renderInput={(params) => <TextField {...params} label="AREA" />}
              isOptionEqualToValue={(option, value) =>
                option.value === value.value
              }
              disableClearable
            />
          </div>
          <div>
            <BootstrapButton
              variant="contained"
              disableRipple
              sx={{ width: "100%", mt: 2, height: 50, mb: 3 }}
              onClick={handleCreateData}
              disabled={isLoading}
            >
              {isLoading ? "Loading..." : "Submit"}
            </BootstrapButton>
          </div>
        </div>
      </Box>
    </Modal>
  );
}

export default ModalCreateRegency;
